import { Autocomplete, Select, NumberInput } from '@mantine/core';
import PropTypes from 'prop-types';
import { IconSearch } from '@tabler/icons-react';
import { DatePicker } from '@mantine/dates';

const ColumnFilter = (obj) => {
  const {
    filters,
    setFilters,
    accessor,
    options = [],
    label = '',
    type = 'autoComplete',
  } = obj;

  const globalProps = {
    label,
    value: filters[accessor],
    leftSection: <IconSearch />,
    clearable: true,
    searchable: true,
    data: options,
    onChange: (value) => {
      setFilters((prev) => ({ ...prev, [accessor]: value }));
    },
  };

  const inputComponents = {
    autoComplete: {
      componentName: Autocomplete,
      componentProps: {
        onClear: () => {
          setFilters((prev) => ({ ...prev, [accessor]: '' }));
        },
      },
    },
    datePicker: {
      componentName: DatePicker,
      componentProps: {
        value: filters[accessor] || [null, null],
        onChange: (value) => {
          setFilters((prev) => ({ ...prev, [accessor]: value }));
        },
        type: 'range',
      },
    },
    select: {
      componentName: Select,
    },
    numberInput: {
      componentName: NumberInput,
      componentProps: {
        onClear: () => {
          setFilters((prev) => ({ ...prev, [accessor]: '' }));
        },
        allowNegative: false,
        allowDecimal: false,
        hideControls: true,
      },
    },
  };

  const component = inputComponents[type];
  const ComponentName = component.componentName;
  return <ComponentName {...globalProps} {...component.componentProps} />;
};

ColumnFilter.propTypes = {
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  accessor: PropTypes.string,
  options: PropTypes.array,
  label: PropTypes.string,
  type: PropTypes.string,
};

export default ColumnFilter;
